import React, { useState, useEffect } from 'react';
import './styles/global.css';
import PasswordList from './components/PasswordList';
import AddPassword from './components/AddPassword';
import Login from './components/Login';
import { FiPlus, FiMoon, FiSun, FiLogOut } from 'react-icons/fi'; // 引入月亮和太阳图标

const App = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [theme, setTheme] = useState('light'); // 默认主题为浅色
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage('');
      }, 3000); // 3秒后清除消息
      return () => clearTimeout(timer); // 组件卸载时清除定时器
    }
  }, [message]);

  //  设置主题
  useEffect(() => {
    document.body.setAttribute('data-theme', theme); // 将主题设置到 body 元素的 data-theme 属性上
  }, [theme]);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
  };

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('parchment');
    } else {
      setTheme('light');
    }
  };

  const onCreate = async (values) => {
    try {
      if (!isLoggedIn) {
        setMessage('请先登录');
        return;
      }
      const response = await fetch('/api/addPassword', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      if (response.ok) {
        setVisible(false);
        setMessage('密码添加成功');
        window.location.reload();
      } else {
        const errorData = await response.json();
        console.error('添加密码失败', errorData);
        setMessage(`添加密码失败: ${errorData.message}`);
      }
    } catch (error) {
      console.error('添加密码时出错:', error);
      setMessage(`添加密码时出错: ${error.message}`);
    }
  };

  return (
    <div className="app-container">
      {!isLoggedIn ? (
        <Login onLogin={handleLogin} />
      ) : (
        <>
          <header className="app-header">
            <div className="header-content">
              <button className="icon-button" onClick={handleLogout}>
                <FiLogOut className="icon" />
              </button>
              <h1 className="app-title">密码库</h1>
              <button className="icon-button" onClick={toggleTheme}>
                {theme === 'light' ? <FiMoon className="icon" /> : theme === 'dark' ? <FiSun className="icon" /> : <FiSun className="icon" />}
              </button>
            </div>
          </header>

          <main className="main-content">
            <div className="floating-actions">
              <button
                onClick={() => setVisible(true)}
                className="fab primary"
              >
                <FiPlus className="icon" style={{ color: 'var(--text-primary)' }} />
              </button>
            </div>

            <PasswordList setMessage={setMessage} />

            <AddPassword
              visible={visible}
              onCreate={onCreate}
              onCancel={() => setVisible(false)}
            />

            {message && (
              <div className="snackbar">
                {message}
              </div>
            )}
          </main>
        </>
      )}
    </div>
  );
};

export default App;
